import useFollowing from "@/lib/useFollowing";
import { Star } from "lucide-react";

// A contestant name you can tap anywhere to follow (uses the normal follow/credit rules
// via useFollowing — a credit charge or paywall is handled globally).
export function FollowableName({ name, className = "" }) {
  const { isFollowing, follow } = useFollowing();
  if (!name) return null;
  const f = isFollowing(name);
  return (
    <button
      type="button"
      data-testid={`follow-name-${name}`}
      title={f ? `Following ${name}` : `Tap to follow ${name}`}
      onClick={(e) => { e.stopPropagation(); if (!f) follow(name); }}
      className={`group inline-flex items-center gap-1 text-left max-w-full ${className}`}
    >
      <span className="truncate group-hover:underline">{name}</span>
      <Star className={`w-3 h-3 shrink-0 ${f ? "fill-current text-[#C8000F]" : "text-current opacity-40 group-hover:opacity-80"}`} />
    </button>
  );
}

export default FollowableName;
